import { render, staticRenderFns } from "./danhSachTraiCay.vue?vue&type=template&id=89427bc8&scoped=true&"
import script from "./danhSachTraiCay.vue?vue&type=script&lang=js&"
export * from "./danhSachTraiCay.vue?vue&type=script&lang=js&"
import style0 from "./danhSachTraiCay.vue?vue&type=style&index=0&id=89427bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89427bc8",
  null
  
)

export default component.exports